import React, { useState } from "react";
import OrganizationDetails from "./OrganizationDetails";
import InviteAdmin from "./InviteAdmin";
import SystemAdminsList from "./SystemAdminsList";
import OrganizationDetailsModal from "./OrganizationDetailsModal";

const OrgSetupLanding: React.FC = () => {
  const [orgModalOpen, setOrgModalOpen] = useState(false);

  const handleEditOrganization = () => {
    setOrgModalOpen(true);
  };

  return (
    <div className="flex flex-col gap-5">
      <div>
        <p className="page-title">Organization Setup</p>
        <p className="page-subtitle">
          Configure your organization details and manage team members to get
          started with the system.
        </p>
      </div>

      <div className="flex flex-col gap-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-5 items-stretch">
          <OrganizationDetails onEditClick={handleEditOrganization} />
          <InviteAdmin/>
        </div>

        <SystemAdminsList />
      </div>

      {/* ✅ Modal rendering here */}
      {orgModalOpen && (
        <OrganizationDetailsModal
          isOpen={orgModalOpen}
          onOpenChange={setOrgModalOpen}
        />
      )}
    </div>
  );
};

export default OrgSetupLanding;